<template >
  <div id="saleby-subcategory"></div>
</template>

<script>
export default {
  name: 'subcategory-sale-chart',
  props: ['saleData'],
  watch: {
    saleData(val) {
      this.createChart()
    }
  },
  mounted() {
    this.createChart()
  },
  methods: {
    createChart() {

      let newData = []
      if (this.saleData) {
        this.saleData.map(row => {
          newData.push([row.SubCategoryName, parseFloat(row.SaleAmount)])
        })
      }
      var HighChartLine = $('#saleby-subcategory');
      if (HighChartLine.length) {
        HighChartLine.highcharts({
          credits: false, // Disable HighCharts logo
          colors: ['#4a89dc', '#3bafda', '#8A1B1D'],// Set Colors
          chart: {
            type: 'column'
          },
          title: {
            text: null
          },
          tooltip: {
            pointFormat: '{series.name}: <b>{point.y:.1f}</b>'
          },
          plotOptions: {
            showInLegend: true
          },
          xAxis: {
            type: 'category',
            labels: {
              rotation: -45,
              style: {
                fontSize: '13px',
                fontFamily: 'Verdana, sans-serif'
              }
            }
          },
          yAxis: {
            min: 0,
            title: {
              text: 'Sale'
            }
          },
          legend: {
            enabled: false,

          },
          series: [{
            name: 'Sale',
            data: newData,
            dataLabels: {
              enabled: true,
              rotation: -90,
              color: '#FFFFFF',
              align: 'right',
              format: '{point.y:.1f}', // one decimal
              y: 10, // 10 pixels down from the top
              style: {
                fontSize: '13px',
                fontFamily: 'Verdana, sans-serif'
              }
            }
          }]
        })
      }

    }
  }
}
</script>
